/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.queryStatuses'

export { $nsid }

/** View moderation statuses of subjects (record or repo). */
const main = l.query(
  $nsid,
  l.params({
    queueCount: l.optional(l.integer()),
    queueIndex: l.optional(l.integer()),
    queueSeed: l.optional(l.string()),
    includeAllUserRecords: l.optional(l.boolean()),
    subject: l.optional(l.string({ format: 'uri' })),
    comment: l.optional(l.string()),
    reportedAfter: l.optional(l.string({ format: 'datetime' })),
    reportedBefore: l.optional(l.string({ format: 'datetime' })),
    reviewedAfter: l.optional(l.string({ format: 'datetime' })),
    hostingDeletedAfter: l.optional(l.string({ format: 'datetime' })),
    hostingDeletedBefore: l.optional(l.string({ format: 'datetime' })),
    hostingUpdatedAfter: l.optional(l.string({ format: 'datetime' })),
    hostingUpdatedBefore: l.optional(l.string({ format: 'datetime' })),
    hostingStatuses: l.optional(l.array(l.string())),
    reviewedBefore: l.optional(l.string({ format: 'datetime' })),
    includeMuted: l.optional(l.boolean()),
    onlyMuted: l.optional(l.boolean()),
    reviewState: l.optional(
      l.string<{
        knownValues: [
          'tools.ozone.moderation.defs#reviewOpen',
          'tools.ozone.moderation.defs#reviewClosed',
          'tools.ozone.moderation.defs#reviewEscalated',
          'tools.ozone.moderation.defs#reviewNone',
        ]
      }>(),
    ),
    ignoreSubjects: l.optional(l.array(l.string({ format: 'uri' }))),
    lastReviewedBy: l.optional(l.string({ format: 'did' })),
    sortField: l.optional(
      l.withDefault(
        l.enum([
          'lastReviewedAt',
          'lastReportedAt',
          'reportedRecordsCount',
          'takendownRecordsCount',
          'priorityScore',
        ]),
        'lastReportedAt',
      ),
    ),
    sortDirection: l.optional(l.withDefault(l.enum(['asc', 'desc']), 'desc')),
    takendown: l.optional(l.boolean()),
    appealed: l.optional(l.boolean()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    tags: l.optional(l.array(l.string(), { maxLength: 25 })),
    excludeTags: l.optional(l.array(l.string())),
    cursor: l.optional(l.string()),
    collections: l.optional(
      l.array(l.string({ format: 'nsid' }), { maxLength: 20 }),
    ),
    subjectType: l.optional(l.string<{ knownValues: ['account', 'record'] }>()),
    minAccountSuspendCount: l.optional(l.integer()),
    minReportedRecordsCount: l.optional(l.integer()),
    minTakendownRecordsCount: l.optional(l.integer()),
    minPriorityScore: l.optional(l.integer({ minimum: 0, maximum: 100 })),
    minStrikeCount: l.optional(l.integer({ minimum: 1 })),
    ageAssuranceState: l.optional(
      l.string<{
        knownValues: ['pending', 'assured', 'unknown', 'reset', 'blocked']
      }>(),
    ),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    subjectStatuses: l.array(
      l.ref<ModerationDefs.SubjectStatusView>(
        (() => ModerationDefs.subjectStatusView) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
